import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = ['count', 'minutes']
  static values = { url: String, interval: { type: Number, default: 5000 } }

  connect() {
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async poll() {
    const response = await get(this.urlValue, { responseKind: 'json' })
    if (!response.ok) return

    const data = await response.json
    if (this.hasCountTarget) this.countTarget.textContent = data.call_logs_count
    if (this.hasMinutesTarget) this.minutesTarget.textContent = data.call_logs_minutes
  }
}
